import {MerchantState} from '@web/core/constants'

import {DeliveryDirection, DeliveryMethod, DeliveryStatus, Operator} from '../constants'
import {DeliveryTrackingState} from '../interfaces'

export const getInitialState = (): DeliveryTrackingState => {
    return {
        operatorType: Operator.CUSTOMER,
        deliveryId: '',
        deliveryDirection: DeliveryDirection.ORIGINAL,
        deliveryMethod: DeliveryMethod.DELIVERY,
        deliveryStatus: DeliveryStatus.READY,
        deliveryAttributeType: 'NORMAL',
        arrivalInfo: {},
        tracking: {
            events: [],
        },
        orderSummary: {
            orderNo: '',
            orderDateTime: '',
            orderAmount: 0,
            mainPaymentMethod: null,
            isGiftReceiver: false,
            product: {
                orderNo: '',
                name: '',
                imageUrl: '',
                ecNvMid: 0,
            },
            merchant: {
                name: '',
                no: 0,
                imageUrl: '',
                phone: '',
                email: '',
                status: MerchantState.STATE_CODE_TRADE_INTERRUPTION,
                isTalkEnabled: false,
                isLogisticsDirectContracted: false,
            },
        },
    }
}
